import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import '../../css/gstIncHtmlPage.scss'
import {getGstInvoiceData} from '../../store/reports/reports_action'
import { connect } from 'react-redux'
import { withDecimal } from '../common/helper'

const GstInvoice = ({data,getGstInvoiceData}) => {
  const { reports } = data
  const {gstInvoiceData}=reports
  const[daata,setDaata]=useState()

  const [searchParams, setSearchParams] = useSearchParams()
  const BookingID = searchParams.get('intbookingid')
  const CompanyID = searchParams.get('companyid')
  const EventType = searchParams.get('EventType')
  //getGstInvoiceData
  useEffect(()=>{
    const obj={
        BookingID:Number(BookingID),
        CompanyID:Number(CompanyID),
        EventType:EventType,
    }

    getGstInvoiceData(obj)
  },[])
  useEffect(()=>{   
    if(gstInvoiceData?.status==="Success"){
        setDaata(gstInvoiceData?.Data?.Table?.[0])
    }
  },[gstInvoiceData])
  

  return (
    <div classNameName="gstInvoiceContainer">
   <div className="container" style={{margin: '0 !important', paddingTop: '4px !important', background: 'black', boxSizing: 'border-box'}}>
   <div id="section-to-print" className="main_container" size="A4" style={{width: '27.83cm', border: '1px solid', backgroundColor: 'white', margin: 'auto', padding: 10}}>
    <div className="top_section" style={{width: '100%'}}>
      <div style={{width: '100%', textAlign: 'center', paddingTop: 10}}>
        <img src={daata?.LogoURL} />

      </div>
      <div style={{width: '100%', textAlign: 'center', paddingBottom: 5}}>
        <h2> {daata?.OperatorName} </h2>
      </div>
      <div style={{width: '100%', textAlign: 'center', fontSize: 13, fontWeight: 400, padding: '0'}}>
        <h5 style={{fontSize: 13, fontWeight: 400,  margin: '0 5px'}}>{daata?.OperatorAddress}</h5>
      </div>
      <div style={{width: '100%', textAlign: 'center', paddingBottom: 20}}>
        <h5 style={{fontSize: 13, fontWeight: 400,  margin: '0 5px'}}>{daata?.OperatorEmailID}, Contact:{daata?.OperatorPhone1},{daata?.OperatorPhone2}</h5>
      </div>
    </div>
    <div className="middle_section">
      <div style={{display: 'flex', width: '100%', border: '1px solid black'}}>
        <div style={{width: '45%', borderRight: '1px solid'}}>
          <div style={{borderBottom: '1px solid', padding: '5px 25px',marginTop:"-15px"}}>
            <h4 style={{fontSize: 14, fontWeight: 600,  letterSpacing: '2%', padding: '0',height:"6px"}}>{daata?.ProviderCompanyName}, {daata?.CompanyCity}</h4>
            <p style={{padding: '0', fontSize: 14, fontWeight: 500,  letterSpacing: '2%',height:"20px"}}>{daata?.CompanyAddress1}</p>
            <h4 style={{fontSize: 14, fontWeight: 600,  letterSpacing: '2%', padding: '0',height:"4px"}}>GSTIN: {daata?.ServiceProviderGSTIN}</h4>
            <div style={{display: 'flex'}}>
              <table>
                <tbody><tr>
                    <td style={{fontWeight: 500, fontSize: 14, }}><b>State Name:</b></td>
                    <td style={{fontWeight: 500, fontSize: 14, }}><b>{daata?.StateName}</b></td>
                  </tr>
                </tbody></table>
              <table>
                <tbody><tr>
                    <td style={{fontWeight: 500, fontSize: 14, }}><b>Code:</b></td>
                    <td style={{fontWeight: 500, fontSize: 14, }}><b>{daata?.StateCode}</b></td>
                  </tr>
                </tbody></table>
            </div>  
          </div>
          <div style={{borderBottom: '1px solid', padding: '5px 25px',marginTop:"-15px"}}>
            <h4 style={{fontSize: 14, fontWeight: 600,  letterSpacing: '2%', padding: '0',height:"5px"}}>Consignee (Bill To)</h4>
            <h4 style={{fontSize: 14, fontWeight: 600,  letterSpacing: '2%', padding: '0',height:"5px"}}>{daata?.ServiceReceiverName}</h4>
            <h4 style={{fontSize: 14, fontWeight: 600,  letterSpacing: '2%', padding: '0',height:"5px"}}>{daata?.ServiceReceiverState}</h4>
            <p style={{padding: '0', fontSize: 14, fontWeight: 500,  letterSpacing: '2%',height:"5px"}}>{daata?.ServiceReceiverAddress}</p>
            <h4 style={{fontSize: 14, fontWeight: 600,  letterSpacing: '2%', padding: '0',height:"5px"}}>{daata?.ServiceReceiverGSTIN}</h4>
            <div style={{display: 'flex'}}>
              <table>
                <tbody><tr>
                    <td style={{fontWeight: 500, fontSize: 14, }}><b>State Name:</b></td>
                    <td style={{fontWeight: 500, fontSize: 14, }}><b>{daata?.SRStateName}</b></td>
                  </tr>
                </tbody></table>
              <table>
                <tbody><tr>
                    <td style={{fontWeight: 500, fontSize: 14, }}><b>Code:</b></td>
                    <td style={{fontWeight: 500, fontSize: 14, }}><b>{daata?.SRStateCode}</b></td>
                  </tr>
                </tbody></table>
            </div>  
          </div>
          <div style={{padding: '5px 25px',margin:"-15px 0"}}>
            <h4 style={{fontSize: 14, fontWeight: 600,  letterSpacing: '2%', padding: '0',height:"5px"}}>Buyer (Ship To)</h4>
            <h4 style={{fontSize: 14, fontWeight: 600,  letterSpacing: '2%', padding: '0',height:"5px"}}><b>{daata?.ServiceReceiverName2}</b></h4>
            <h4 style={{fontSize: 14, fontWeight: 600,  letterSpacing: '2%', padding: '0',height:"5px"}}><b>{daata?.ServiceReceiverCity2}</b></h4>
            <p style={{padding: '0', fontSize: 14, fontWeight: 500,  letterSpacing: '2%',height:"5px"}}>{daata?.ServiceReceiverAddress2}</p>
            <h4 style={{fontSize: 14, fontWeight: 600,  letterSpacing: '2%', padding: '0',height:"5px"}}>{daata?.ServiceReceiverGSTIN2}</h4>
            <div style={{display: 'flex',height:"5px"}}>
              <table>
                <tbody><tr>
                    <td style={{fontWeight: 500, fontSize: 14, }}><b>State Name:</b></td>
                    <td style={{fontWeight: 500, fontSize: 14, }}><b>{daata?.StateName2}</b></td>
                  </tr>
                </tbody></table>
              <table>
                <tbody><tr>
                    <td style={{fontWeight: 500, fontSize: 14, }}><b>Code:</b></td>
                    <td style={{fontWeight: 500, fontSize: 14, }}><b>{daata?.StateCode2}</b></td>
                  </tr>
                </tbody></table>
            </div>  
          </div>
        </div>
        <div style={{width: '55%'}}>
          <table cellSpacing={0} border={0} className="right-table" cellPadding={0} style={{width: '100%', height: 75}}>
            <tbody>
              <tr style={{height: 75,width:"100%"}}>
                <td style={{borderRight: '1px solid black', borderBottom: '1px solid black',width:"50%"}}>
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>Invoice No:</h5>
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>{daata?.GSTInvoiceNo}</h5>
                </td>
                <td style={{borderBottom: '1px solid black',width:"50%"}}>                   
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>Invoice Date:</h5>
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>{daata?.GSTInvoiceDate}</h5>                  
                </td>
              </tr>
              <tr style={{height: 75,width:"100%"}}>
                <td style={{borderRight: '1px solid black', borderBottom: '1px solid black',width:"50%"}}>                    
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>Mode/Terms of Payment:</h5>
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>{daata?.PaymentType}</h5>                    
                </td>
                <td style={{borderBottom: '1px solid black',width:"50%"}}>                    
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>Destination:</h5>
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>{daata?.DestinationCity}</h5>                   
                </td>
              </tr>
              <tr style={{height: 75,width:"100%"}}>
                <td style={{borderRight: '1px solid black', borderBottom: '1px solid black',width:"50%"}}>                    
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>Reference No and Date:</h5>
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>{daata?.BillNo}</h5>                    
                </td>
                <td style={{borderBottom: '1px solid black',width:"50%"}}>                    
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>Other References:</h5>
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>NA</h5>                   
                </td>
              </tr>
              <tr style={{height: 75,width:"100%"}}>
                <td style={{borderRight: '1px solid black', borderBottom: '1px solid black',width:"50%"}}>                  
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>Buyer s Order No.:</h5>
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>{daata?.WAYBILLNO}</h5>                
                </td>
                <td style={{borderBottom: '1px solid black',width:"50%"}}>                  
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>Order Date:</h5>
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>{daata?.OrderDate}</h5>                   
                </td>
              </tr>
              <tr style={{height: 75,width:"100%"}}>
                <td style={{borderRight: '1px solid black', borderBottom: '1px solid black',width:"50%"}}>                   
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>Dispatch Doc No.:</h5>
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>NA</h5>                    
                </td>
                <td style={{borderBottom: '1px solid black',width:"50%"}}>                  
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>Dispatched Through:</h5>
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>NA</h5>                   
                </td>
              </tr>
              <tr style={{height: 75,width:"100%"}}>
                <td style={{borderRight: '1px solid black',width:"50%"}}>                    
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>Delivery Note:</h5>
                  <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>NA</h5>
                </td>
                <td style={{width:"50%"}}>
                  <div className="row-right" style={{borderBottom: 'none'}}>
                    <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>Delivery Note Date:</h5>
                    <h5 style={{fontWeight: 400, fontSize: 14,  margin: '0 25px'}}>{daata?.DeliveryNoteDate}</h5>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="transport_Table1" style={{width: '100%', paddingTop: 10}}>
        <table className="middle_table border-table" cellSpacing={0} cellPadding={0} style={{width: '100%', fontWeight: 500, fontSize: 13,  borderCollapse: 'collapse', margin: 'auto'}}>
          <thead>
            <tr style={{backgroundColor: '#D9D9D9'}}>
              <th style={{border: '1px solid black', padding: '10px 0'}}>SN</th>
              <th style={{border: '1px solid black', padding: '10px 0', whiteSpace: 'nowrap'}}>DISCRIPTION OF GOODS</th>
              <th style={{border: '1px solid black', padding: '10px 0'}}>HSN/SAC</th>
              <th style={{border: '1px solid black', padding: '10px 0'}}>QTY</th>
              <th style={{border: '1px solid black', padding: '10px 0'}}>RATE</th>
              <th style={{border: '1px solid black', padding: '10px 0'}}>TAXABLE</th>
              <th style={{border: '1px solid black', padding: '10px 0'}}>CGST</th>
              <th style={{border: '1px solid black', padding: '10px 0'}}>SGST</th>
              <th style={{border: '1px solid black', padding: '10px 0'}}>IGST</th>
              <th style={{border: '1px solid black', padding: '10px 0'}}>AMOUNT</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{textAlign: 'center'}}>
              <td style={{border: '1px solid black', padding: '10px 0'}}>1</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.DESCRIPTION}</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.HSNCODE}</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.NOOFPARCEL}</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.RATE}</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.TAXABLE}</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.CGST}</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.SGST}</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.IGST}</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.AMOUNT}</td>
            </tr>
            <tr style={{textAlign: 'center'}}>
              <td style={{border: '1px solid black', padding: '10px 0'}} />
              <td style={{border: '1px solid black', padding: '10px 0'}} />
              <td style={{border: '1px solid black', padding: '10px 0'}} />
              <td style={{border: '1px solid black', padding: '10px 0'}} />
              <td style={{border: '1px solid black', padding: '10px 0'}}>TOTAL</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.TAXABLE}</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.CGST}</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.SGST}</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.IGST}</td>
              <td style={{border: '1px solid black', padding: '10px 0'}}>{daata?.AMOUNT}</td>
            </tr>
            <tr>              
              <td colSpan={7} style={{whiteSpace: 'nowrap', border: '1px solid black', padding: 10}}><b>Invoice Total (Words):</b>{withDecimal(daata?.AMOUNT||0)}</td>
              <td colSpan={2} style={{whiteSpace: 'nowrap', border: '1px solid black', padding: 10}}><b>Total (Figures)</b></td>
              <td style={{border: '1px solid black',textAlign:"center"}}><b>{daata?.AMOUNT}</b></td>  
            </tr>        
          </tbody>
        </table>
      </div>
      <div className="taxable_table2" style={{width: '100%', paddingTop: 10}}>
        <table className="middle_table2 border-table" width="100%" cellSpacing={0} cellPadding={0} style={{fontWeight: 500, fontSize: 13,  borderCollapse: 'collapse', border: '1px solid black', padding: 10}}>
          <thead>
            <tr style={{backgroundColor: '#D9D9D9', width: '100%', textAlign: 'left'}}>
              <th style={{border: '1px solid black', padding: 10}}>HSN/SAC</th>
              <th style={{border: '1px solid black', padding: 10}}>TOTAL</th>
              <th colSpan={2} style={{border: '1px solid black', padding: 10}}>CENTRAL GST</th>
              <th colSpan={2} style={{border: '1px solid black', padding: 10}}>STATE GST</th>
              <th colSpan={2} style={{border: '1px solid black', padding: 10}}>INTEGRATED GST</th>
              <th style={{border: '1px solid black', padding: 10}}>TOTAL</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{textAlign: 'left'}}>
              <td style={{border: '1px solid black', padding: 10}}>Code</td>
              <td style={{border: '1px solid black', padding: 10}}>Taxable Amount</td>
              <td style={{border: '1px solid black', padding: 10}}>Rate</td>
              <td style={{border: '1px solid black', padding: 10}}>Amount</td>
              <td style={{border: '1px solid black', padding: 10}}>Rate</td>
              <td style={{border: '1px solid black', padding: 10}}>Amount</td>
              <td style={{border: '1px solid black', padding: 10}}>Rate</td>
              <td style={{border: '1px solid black', padding: 10}}>Amount</td>
              <td style={{whiteSpace: 'nowrap', border: '1px solid black', padding: 10}}>Tax Amount</td>
            </tr>
            <tr style={{textAlign: 'left'}}>
              <td style={{border: '1px solid black', padding: 10}}>{daata?.Code}</td>
              <td style={{whiteSpace: 'nowrap', border: '1px solid black', padding: 10}}>{daata?.TaxableAmount}</td>
              <td style={{border: '1px solid black', padding: 10}}>{daata?.CRate}</td>
              <td style={{border: '1px solid black', padding: 10}}>{daata?.CAmount}</td>
              <td style={{border: '1px solid black', padding: 10}}>{daata?.SRate}</td>
              <td style={{border: '1px solid black', padding: 10}}>{daata?.SAmount}</td>
              <td style={{border: '1px solid black', padding: 10}}>{daata?.IRate}</td>
              <td style={{border: '1px solid black', padding: 10}}>{daata?.IAmount}</td>
              <td style={{whiteSpace: 'nowrap', border: '1px solid black', padding: 10}}>{daata?.TaxAmount}</td>
            </tr>
            <tr>              
              <td colSpan={6} style={{whiteSpace: 'nowrap', border: '1px solid black', padding: 10}}><b>Tax Total (Words):</b>{withDecimal(daata?.TaxAmount||0)}</td>
              <td colSpan={2} style={{whiteSpace: 'nowrap', border: '1px solid black', padding: 10}}><b>Total (Figures)</b></td>
              <td style={{border: '1px solid black', padding: 10}}><b>{daata?.TaxAmount}</b></td>  
            </tr>        
          </tbody>
        </table>
      </div>
      <div className="footer" style={{display: 'flex', border: '1px solid', marginTop: 10}}>
        <table width="50%" style={{borderRight: '1px solid'}}>
          <tbody>
            <tr>
              <td>
                <div>
                  <h5 style={{paddingLeft: '3PX', fontSize: 13, fontWeight: 400,  margin: '0 5px'}}><b>Declaration:</b></h5>
                  <p style={{paddingLeft: 8, fontSize: 14, fontWeight: 500,  letterSpacing: '2%'}}>We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <table width="50%" style={{textAlign: 'right'}}>
          <tbody>
            <tr>
              <td>
                <div>
                  <h5 style={{paddingBottom: 26, fontSize: 13, fontWeight: 400,  margin: '0 5px'}}><b>For,{daata?.OperatorName}</b></h5> 
                  <p style={{paddingRight: 5, fontSize: 14, fontWeight: 500,  letterSpacing: '2%'}}>Authorised Signatory</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


    </div>
  )
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
    getGstInvoiceData
}

export default connect(mapStateToProps, mapDispatchToProps)(GstInvoice)
